
import {Component, Vue, Watch} from 'vue-property-decorator';
import stores from '../../stores';

@Component({
  components: {},
})

export default class DeletePackage extends Vue {
  /**
   * Fired when this module is created
   */
  created() {
    this.delete();
  }

  delete() {
    return stores.Package.deleteItem(Number(this.$route.params.id))
      .then(() => {
        this.$router.push({name: 'packages', params: {folderId: '1'}});
      })
      .catch((reason) => {
        console.error('Could not delete', reason);
      });
  }
}
